import PatternIframe from "../../../../src/pages/pattern/component/PatternIframe.jsx";
import ChecklistResourcesSection from "../../../../src/components/ChecklistResourcesSection/ChecklistResourcesSection.jsx";
import * as React from 'react';
export default {
  PatternIframe,
  ChecklistResourcesSection,
  React
};